import React from 'react';
import {
  makeStyles,
  Paper,
  Button,
  Typography,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
} from '~/lib/bn-material-ui';
import { useQuery } from './use-query';
// import InventoryGraph from './inventory-graph';
import InventoryTable from './inventory-table';
import BnButtonGroup from '../common/bn-button-group';
import classNames from 'classnames';
import { useLocalStorage } from '~/common/use-storage';
import InventoryMapPage from './inventory-map/inventory-map-page';

const useStyles = makeStyles(theme => {
  return {
    header: {
      display: 'flex',
      alignItems: 'center',
      gap: '2rem',
      padding: '1rem',
      flexWrap: 'wrap',
      borderRadius: '0',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'stretch',
      },
    },
    grouping: {
      display: 'flex',
      gap: '1rem',
      alignItems: 'center',
      [theme.breakpoints.down('lg')]: {
        display: 'none',
      },
    },
    groupingVertical: {
      display: 'flex',
      flexDirection: 'column',
    },
    options: {
      flexGrow: 1,
      justifyContent: 'flex-end',
    },
  };
});

export function InventoryPage() {
  const styles = useStyles();
  const [{
    sort = 'name',
    order = 'asc',
  }, updateQuery] = useQuery();
  const [view, setView] = useLocalStorage('inventory.view', 'map');

  return <>
    <Paper className={styles.header}>
      <div className={styles.groupingVertical}>
        <Typography variant='h1'>Facility Inventory</Typography>
        <BnButtonGroup value={view} onClick={value => setView(value)}>
          <Button value='map'>Map</Button>
          <Button value='table'>Table</Button>
        </BnButtonGroup>
      </div>
      <div className={styles.grouping}>
        <div className={classNames(styles.options, styles.grouping)}>

          <FormControl>
            <InputLabel htmlFor='sort-by-input'>Sort By:</InputLabel>
            <Select id='sort-by-input' value={sort} onChange={e => updateQuery({ sort: e.target.value })}>
              {/* <MenuItem value='capacity'>Available Capacity</MenuItem> */}
              <MenuItem value='name'>Bin Name</MenuItem>
              <MenuItem value='volume'>Current Level</MenuItem>
              <MenuItem value='percent'>% Filled</MenuItem>
              <MenuItem value='material'>Material</MenuItem>
            </Select>
          </FormControl>
          <FormControl id='blank-input-label'>
            <InputLabel htmlFor='blank-input-label'> </InputLabel>
            <Select value={order} onChange={e => updateQuery({ order: e.target.value })}>
              <MenuItem value='asc'>Ascending</MenuItem>
              <MenuItem value='desc'>Descending</MenuItem>
            </Select>
          </FormControl>
        </div>
      </div>
    </Paper>
    <div className={styles.content}>
      {view === 'map' && <InventoryMapPage />}
      {view === 'table' && <InventoryTable />}
    </div>
  </>;
}
